import {da, enUS, nb, sv} from 'date-fns/locale';

export enum LOCALE_CODES {
  NO = 'no',
  EN = 'en',
  SV = 'sv',
  DA = 'da'
}

export const DEFAULT_LOCALE = LOCALE_CODES.NO;

export const LOCALE_VALUES = {
  [LOCALE_CODES.NO]: {
    name: 'Norsk',
    code: LOCALE_CODES.NO
  },
  [LOCALE_CODES.EN]: {
    name: 'English',
    code: LOCALE_CODES.EN
  },
  [LOCALE_CODES.SV]: {
    name: 'Svenska',
    code: LOCALE_CODES.SV
  },
  [LOCALE_CODES.DA]: {
    name: 'Dansk',
    code: LOCALE_CODES.DA
  }
};

export const LOCALES = Object.values(LOCALE_VALUES);

export const CALENDAR_LOCALE_CODES = {
  [LOCALE_CODES.NO]: {code: 'nb-NO'},
  [LOCALE_CODES.EN]: {code: 'en-US'},
  [LOCALE_CODES.DA]: {code: 'da-DK'},
  [LOCALE_CODES.SV]: {code: 'sv-SE'}
};

export const DATE_FNS_FORMAT_LOCALES = {
  [LOCALE_CODES.EN]: enUS,
  [LOCALE_CODES.NO]: nb,
  [LOCALE_CODES.DA]: da,
  [LOCALE_CODES.SV]: sv
};
